import type { RouteId, RouteParams } from '$app/types';

// Not $app/paths `resolve`: Playwright loads specs in plain Node, where $app does not resolve.
export function route<T extends RouteId>(
    ...[id, params]: RouteParams<T> extends Record<string, never> ? [id: T] : [id: T, params: RouteParams<T>]
): string {
    const values = (params ?? {}) as Record<string, string | undefined>;

    const path = (id as string)
        .replace(/\/\([^/)]+\)/g, '')
        .replace(/\/\[\[(?:\.\.\.)?([^\]=]+?)(?:=[^\]]+)?\]\]/g, (_, name: string) => {
            const value = values[name];
            return value === undefined || value === '' ? '' : `/${value}`;
        })
        .replace(/\[(?:\.\.\.)?([^\]=]+?)(?:=[^\]]+)?\]/g, (_, name: string) => {
            const value = values[name];
            if (value === undefined || value === '') throw new Error(`Missing parameter '${name}' in route ${id}`);
            if (value.startsWith('/') || value.endsWith('/'))
                throw new Error(`Parameter '${name}' in route ${id} cannot start or end with a slash`);
            return value;
        });

    return path === '' ? '/' : path;
}

export function formatUrl(baseUrl: string, params: URLSearchParams | undefined = undefined) {
    if (params) return `${baseUrl}?${params?.toString()}`;

    return baseUrl;
}
